var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunitySpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1429_5170)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.8944 48.0823C60.3286 48.0823 65.5446 37.6504 65.5446 24.7819C65.5446 11.9134 60.3286 1.48145 53.8944 1.48145C47.4601 1.48145 42.2441 11.9134 42.2441 24.7819C42.2441 37.6504 47.4601 48.0823 53.8944 48.0823Z",
    fill: "url(#paint0_linear_1429_5170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3165 33.7038L8.91797 27.8916L23.1527 62.9538C24.5177 66.2684 28.3106 67.8493 31.6235 66.4843C34.8999 65.1359 36.4891 61.4078 35.1938 58.1098L25.3165 33.7038Z",
    fill: "url(#paint1_linear_1429_5170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8057 24.7816C56.8057 17.0726 50.5564 10.8232 42.8474 10.8232C41.2541 10.8232 39.7307 11.1024 38.3029 11.5949C37.3877 15.6189 36.8652 20.0736 36.8652 24.7816C36.8652 29.4895 37.3877 33.9462 38.3029 37.9682C39.7287 38.4587 41.2541 38.7399 42.8474 38.7399C50.5564 38.7399 56.8057 32.4906 56.8057 24.7816Z",
    fill: "url(#paint2_linear_1429_5170)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1429_5170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8935 0.0253906C52.9134 0.117136 51.945 0.312277 51.0057 0.607901L7.42958 15.0542C2.57872 16.6269 0.0113089 19.9909 0.0113089 24.7209C-0.211494 29.4393 2.87872 33.6756 7.43832 34.9061L51.0975 48.9839C51.9858 49.3451 52.9353 49.533 53.8935 49.5388C61.2433 49.5388 67 38.6648 67 24.7821C67 10.8994 61.2463 0.0253906 53.8935 0.0253906ZM53.8935 46.6262C48.3684 46.6262 43.6996 36.6231 43.6996 24.7821C43.6996 12.9411 48.3713 2.93794 53.8935 2.93794C59.4157 2.93794 64.0874 12.9411 64.0874 24.7821C64.0874 36.6231 59.4274 46.6262 53.8935 46.6262Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8935 0.0253906C52.9134 0.117136 51.945 0.312277 51.0057 0.607901L7.42958 15.0542C2.57872 16.6269 0.0113089 19.9909 0.0113089 24.7209C-0.211494 29.4393 2.87872 33.6756 7.43832 34.9061L51.0975 48.9839C51.9858 49.3451 52.9353 49.533 53.8935 49.5388C61.2433 49.5388 67 38.6648 67 24.7821C67 10.8994 61.2463 0.0253906 53.8935 0.0253906ZM53.8935 46.6262C48.3684 46.6262 43.6996 36.6231 43.6996 24.7821C43.6996 12.9411 48.3713 2.93794 53.8935 2.93794C59.4157 2.93794 64.0874 12.9411 64.0874 24.7821C64.0874 36.6231 59.4274 46.6262 53.8935 46.6262Z",
    fill: "url(#paint3_linear_1429_5170)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61463 15.6249L7.61464 15.6249L7.61839 15.6237L51.1901 1.17887C52.0786 0.899585 52.9943 0.714196 53.9212 0.625448C57.2612 0.639119 60.367 3.12046 62.6737 7.47843C64.9758 11.8274 66.4 17.9154 66.4 24.7821C66.4 31.6487 64.975 37.7367 62.6727 42.0857C60.3596 46.4548 57.244 48.9376 53.8959 48.9388C53.014 48.9333 52.1405 48.7603 51.3234 48.4281L51.3028 48.4197L51.2816 48.4129L7.62245 34.3351L7.60865 34.3306L7.59465 34.3268C3.30695 33.1697 0.401131 29.186 0.610641 24.7492L0.611309 24.7351V24.7209C0.611309 22.4688 1.22054 20.5785 2.37762 19.0685C3.53693 17.5557 5.2791 16.3822 7.61463 15.6249ZM43.0996 24.7821C43.0996 30.7734 44.2795 36.324 46.1809 40.3983C47.1314 42.4348 48.2738 44.1275 49.5625 45.3188C50.8535 46.5122 52.32 47.2262 53.8935 47.2262C55.469 47.2262 56.9365 46.5124 58.2281 45.3189C59.5174 44.1275 60.6595 42.4347 61.6094 40.3981C63.5098 36.3238 64.6874 30.7733 64.6874 24.7821C64.6874 18.7907 63.5068 13.2402 61.605 9.16587C60.6544 7.12932 59.5119 5.43667 58.2233 4.24538C56.9325 3.05205 55.4663 2.33794 53.8935 2.33794C52.3207 2.33794 50.8545 3.05205 49.5637 4.24538C48.2751 5.43667 47.1326 7.12932 46.182 9.16587C44.2802 13.2402 43.0996 18.7907 43.0996 24.7821Z",
    stroke: "url(#paint4_linear_1429_5170)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1429_5170",
    x: -24,
    y: -23.9746,
    width: 115,
    height: 97.5137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5170"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5170",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5170"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_5170",
    x1: 43.215,
    y1: 10.8016,
    x2: 68.9801,
    y2: 12.5909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_5170",
    x1: 10.0316,
    y1: 35.7083,
    x2: 39.4624,
    y2: 38.5035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_5170",
    x1: 37.6961,
    y1: 16.4066,
    x2: 59.6363,
    y2: 18.5832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1429_5170",
    x1: 2.79167,
    y1: 9.92808,
    x2: 74.6963,
    y2: 23.4419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1429_5170",
    x1: 2.09375,
    y1: 2.276,
    x2: 67,
    y2: 2.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1429_5170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunitySpeaker);
export default __webpack_public_path__ + "static/media/community-speaker.e0120748c45d1874556656a29298276c.svg";
export { ForwardRef as ReactComponent };